import React, { useState } from 'react';
import { Alert, Box } from '@mui/material';
import { supabase } from '../services/supabaseClient';
import { addLancamento } from '../services/api';
import { LancamentoBaseForm, LancamentoFormData } from './LancamentoBaseForm';

interface LancamentoFormProps {
    onLancamentoAdded: () => void;
}

const LancamentoForm: React.FC<LancamentoFormProps> = ({ onLancamentoAdded }) => {
    const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
    const [error, setError] = useState('');
    const [formKey, setFormKey] = useState(Date.now());

    const handleSubmit = async (data: LancamentoFormData, novosAnexos: File[], anexosDeletadosIds: number[]) => {
        setIsLoadingSubmit(true);
        setError('');
        try {
            const { data: { user } } = await supabase.auth.getUser();
            if (!user) throw new Error("Usuário não autenticado. Por favor, faça login novamente.");

            const uploadedAnexos = [];
            for (const file of novosAnexos) {
                const sanitizedFileName = file.name.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9.-]/g, '_');
                const filePath = `${user.id}/${Date.now()}-${sanitizedFileName}`;
                const { error: uploadError } = await supabase.storage.from('anexos').upload(filePath, file);
                if (uploadError) {
                    if (uploadError.message.includes('security policy')) {
                        throw new Error(`Erro de segurança ao enviar o anexo ${file.name}. Verifique as permissões do bucket.`);
                    }
                    throw new Error(`Erro no upload do anexo ${file.name}: ${uploadError.message}`);
                }
                uploadedAnexos.push({ caminho_arquivo: filePath, nome_original: file.name });
            }

            const lancamentoData = {
                ...data,
                desconto_valor: (data.tipo_desconto === 'total' && data.desconto_valor) ? (parseFloat(String(data.desconto_valor)) || 0) : 0,
                desconto_percentual: (data.tipo_desconto === 'total' && data.desconto_percentual) ? (parseFloat(String(data.desconto_percentual)) || 0) : 0,
            };
            delete (lancamentoData as any).items;
            delete (lancamentoData as any).anexos;

            const itemsData = data.items.map(item => ({
                ...item,
                quantidade: parseFloat(String(item.quantidade)) || 0,
                valor_unitario: parseFloat(String(item.valor_unitario)) || 0,
                desconto_valor: parseFloat(String(item.desconto_valor)) || 0,
                desconto_percentual: (item as any).desconto_percentual || 0,
            }));

            await addLancamento(lancamentoData as any, itemsData, uploadedAnexos);

            onLancamentoAdded();
            setFormKey(Date.now()); // Reset o formulário base
            
        } catch (err: any) {
            console.error("Erro ao adicionar lançamento:", err);
            setError(err.message || 'Erro ao adicionar lançamento.');
            throw err;
        } finally {
            setIsLoadingSubmit(false);
        }
    };

    return (
        <Box>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            <LancamentoBaseForm 
                key={formKey}
                isEditMode={false} 
                onSubmit={handleSubmit} 
                onCancel={() => {}} 
                isLoadingSubmit={isLoadingSubmit} 
            />
        </Box>
    );
};

export default LancamentoForm;